import {
  addUploadFiles,
  selectActiveProject,
  selectActiveProjectName,
  uploadFaultFiles,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { DataToSendEvent } from '@core/core/types'
import { getImportDataAnalyticParams } from '@core/core/utils'
import type { FC } from 'react'

import { AddingFilesModal } from './AddingFilesModal'
import type { AddingFilesModalContainerPropsType as PropsType, FormDataType } from './types'
import { useAddingFiles } from './useAddingFiles'
import { useGetDomainItems } from './useGetDomainItems'

const AddingFilesFaultModalContainer: FC<PropsType> = ({ files = null }) => {
  const dispatch = useAppDispatch()
  const domainItems = useGetDomainItems()
  const activeProject = useAppSelector(selectActiveProject)
  const activeProjectName = useAppSelector(selectActiveProjectName)

  const data: DataToSendEvent = {
    id: 'import from file_seismic_end',
    params: getImportDataAnalyticParams(activeProjectName, 'Fault'),
  }

  const { visibleModal, activeFileReady, isOneFileDownloaded, onSave, onSaveForAll, onCancel } =
    useAddingFiles(files, data, (file: File, formData?: FormDataType) => {
      dispatch(addUploadFiles([file.name]))
      dispatch(
        uploadFaultFiles({
          projectId: activeProject.id,
          data: {
            file: { data: file, fileName: file.name },
            name: formData?.objectName,
            domainType: formData?.domain?.id,
          },
        }),
      )
    })

  return (
    <AddingFilesModal
      isModalOpen={visibleModal}
      isOneFileDownload={isOneFileDownloaded}
      isViewObjectName={false}
      fileName={activeFileReady?.name ?? ''}
      domainItems={domainItems}
      onCancel={onCancel}
      onSave={onSave}
      onSaveForAll={onSaveForAll}
    />
  )
}

export { AddingFilesFaultModalContainer }
